export const FETCH_SIGNUP_PENDING = "FETCH_SIGNUP_PENDING";
export const FETCH_SIGNUP_REJECTED = "FETCH_SIGNUP_REJECTED";
export const FETCH_SIGNUP_FULFILLED = "FETCH_SIGNUP_FULFILLED";
export const SIGNUP_SMS_VERIFICATION_FORM_SHOW = "SIGNUP_SMS_VERIFICATION_FORM_SHOW";
export const SIGNUP_SMS_VERIFICATION_FORM_HIDE = "SIGNUP_SMS_VERIFICATION_FORM_HIDE";


// WEBPACK FOOTER //
// ./src/constants/kapidaConstants/signup.js